import { ProductInterface } from "../interfaces/ProductInterface";
import { CategoryListInterface } from "../interfaces/CategoryListInterface";

export const ProductRangeSubCategoryMapper = (
    products: ProductInterface[],
    category: CategoryListInterface,
): CategoryListInterface => {
    const children = category.children?.map((child: CategoryListInterface) => {
        const childProducts = products.filter((product: ProductInterface) =>
            product.categories.includes(child.id),
        );
        const updatedChild = ProductRangeSubCategoryMapper(products, child);
        return {
            ...updatedChild,
            products: childProducts,
        };
    });
    return {
        ...category,
        children,
    };
};
